import { Dropdown } from 'react-bootstrap'
import CustomMenuComponent from '../../../dropdowns/CustomMenuComponent'
import { useMemo } from 'react'

interface ShipWiseFilterComponentProps {
  items: any[]
  title: string
  sortByField: string
  currentSortByField: string
  currentSortByText: string
  onFilterChanged: any
  onSortChanged: any
}

export default function ShipWiseFilterComponent(props: ShipWiseFilterComponentProps) {
  const view = useMemo(() => {
    return <span style={{textAlign: 'center'}}>
      <div style={{cursor: 'pointer'}}>
        <span id={props.sortByField}  onClick={props.onSortChanged}>
          <span className='shipwise-title'>
            {props.title}&nbsp;
          </span>
          <span className='beacon-label'>
            {props.currentSortByField === props.sortByField ? `${props.currentSortByText}` : ''}
          </span>
        </span>

        <CustomMenuComponent 
          key={`${props.sortByField}Filter`} 
          items={
            props.items.map(r => { 
              return <Dropdown.Item 
                key={`${props.sortByField}|${r}`}  // Combine sortByField and value for uniqueness
                id={`${props.sortByField}|${r}`} 
                onClick={props.onFilterChanged}>
                  {`${r}`}
              </Dropdown.Item>
            })
          }
          title='' 
        />
      </div>
      <span style={{float: 'right'}}>
        
      </span>
    </span>
  }, [props, props.items])
  return view
}